export default __webpack_public_path__ + "static/media/icon_9.ad83535b.svg";